import { createAction, props } from '@ngrx/store';
import { Unit } from '../../../units/models/unit';

export const getUnitsSuccess = createAction(
  '[Units/API] Get Units Success',
  props<{units: Unit[]}>()
);

export const getUnitsFailure = createAction(
  '[Units/API] Get Units Failure',
  props<{error: any}>()
);


export const updateUnitNameSuccess = createAction(
  '[Units/API] Update Unit Name Success',
  props<{data: Unit}>()
);

export const updateUnitNameFailure = createAction(
  '[Units/API] Update Unit Name Failure',
  props<{error: any}>()
);

export type UnitsApiActionsUnion = ReturnType<
  typeof getUnitsSuccess |
  typeof getUnitsFailure |
  typeof updateUnitNameSuccess |
  typeof updateUnitNameFailure
>;
